var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79031 31.6295C4.47179 31.6031 0.899597 22.2446 0.899597 17.4785C0.899597 9.6931 6.4011 7.98867 8.52134 7.98867C9.47685 7.98867 10.4971 8.38701 11.397 8.73951C12.0263 8.98539 12.6772 9.23922 13.0391 9.23922C13.2558 9.23922 13.7663 9.0233 14.2171 8.83384C15.1785 8.42756 16.3747 7.92261 17.7677 7.92261C17.7702 7.92261 17.7736 7.92261 17.776 7.92261C18.8162 7.92261 21.97 8.16495 23.8661 11.1878L24.3103 11.8963L23.671 12.4084C22.7579 13.1399 21.0917 14.4742 21.0917 17.1172C21.0917 20.2476 22.9787 21.4514 23.8852 22.0304C24.2854 22.286 24.6996 22.5495 24.6996 23.1259C24.6996 23.5022 21.8704 31.5828 17.7619 31.5828C16.7566 31.5828 16.046 31.262 15.4192 30.9791C14.7849 30.6927 14.2378 30.446 13.3338 30.446C12.8755 30.446 12.296 30.676 11.6825 30.9201C10.8442 31.2523 9.89526 31.6295 8.81854 31.6295H8.79031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7552 0.379395C17.8524 4.29272 15.3442 7.0076 12.8389 6.83733C12.4261 3.71437 15.3439 0.379395 17.7552 0.379395Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.9141950943fdb490c2115f8e6f94e023.svg";
export { ForwardRef as ReactComponent };